import { useDropdownContext } from '../../../DropdownProvider';
import { TOGGLE_MOBILE_NAV_ACTION } from '../../../DropdownProvider/useSingleDropdown';
import { useSegmentInteraction } from '../../../../lib/analytics/useSegmentInteraction';
import { useEffect } from 'react';

export function useHamburgerToggleClick() {
  const { dispatch } = useDropdownContext();
  const sendSegmentInteraction = useSegmentInteraction({
    eventName: 'global_nav_menu_interacted',
    attributes: {
      entity_name: 'global_nav_hamburger',
      navigation_format: 'sidebar',
    },
  });

  function handleHamburgerToggleClick() {
    dispatch(TOGGLE_MOBILE_NAV_ACTION);
    sendSegmentInteraction();
  }

  return handleHamburgerToggleClick;
}

export function useMobileNavBodyLock() {
  const { state } = useDropdownContext();

  useEffect(() => {
    document.body.style.position = state.isShowingMobileNav ? 'fixed' : '';
  }, [state.isShowingMobileNav]);
}
